/* eslint-disable no-param-reassign */
const searchBar = document.querySelector('.js-search-bar');
const searchField = searchBar.querySelector('#search-field');
const pageNames = document.querySelectorAll('.search-container .page-link a');
const searchCategory = document.querySelectorAll('.page-category');
const mainContainer = document.querySelector('main');
/**
 * Polyfill for parents method
 * @param {*} selector
 */
function parents(selector) {
  const elements = [];
  let elem = this;
  const isHaveSelector = selector !== undefined;

    while ((elem = elem.parentElement) !== null) { //eslint-disable-line
    if (elem && elem.nodeType !== window.Node.ELEMENT_NODE) {
      continue; //eslint-disable-line
    }

    if (!isHaveSelector || (elem && elem.matches(selector))) {
      elements.push(elem);
    }
  }

  return elements;
}


window.Element.prototype.parents = parents;


function displaySearchResults() {
  const searchString = searchField.value.toLowerCase();
  const filteredPages = Object.values(pageNames).filter(
    page => page.textContent.toLowerCase().indexOf(searchString) >= 0,
  );
  pageNames.forEach((pageName) => {
    pageName.parentElement.style.display = 'none';
  });
  searchCategory.forEach((category) => {
    category.style.display = 'none';
  });
  if (filteredPages.length > 0) {
    if (mainContainer.classList.contains('no-results')) mainContainer.classList.remove('no-results');
    filteredPages.forEach((item) => {
      item.parentElement.style.display = 'block';
      item.parents('.page-category')[0].style.display = 'block';
    });
  } else {
    mainContainer.classList.add('no-results');
  }
}

window.addEventListener('load', () => {
  if (searchBar) {
    searchField.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) { displaySearchResults(); }
    });
  }
});
